var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("register-credential-puntos-colombia", {
        ref: "register",
        on: { refresh: _vm.refreshConfigs },
      }),
      _c("show-credential-puntos-colombia", {
        ref: "table",
        on: { terminales: _vm.openTerminales, editar: _vm.editarConfiguracion },
      }),
      _c("show-credential-terminales-puntos-colombia", {
        attrs: { config: _vm.selectedConfig },
        model: {
          value: _vm.dialogTerminales,
          callback: function ($$v) {
            _vm.dialogTerminales = $$v
          },
          expression: "dialogTerminales",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }